"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessNumberSelectionMapper = void 0;
var ProcessNumberSelectionMapper = /** @class */ (function () {
    function ProcessNumberSelectionMapper(data) {
        this.localData = data;
    }
    ProcessNumberSelectionMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return ProcessNumberSelectionMapper;
}());
exports.ProcessNumberSelectionMapper = ProcessNumberSelectionMapper;
//# sourceMappingURL=ProcessNumberSelectionMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/ProcessNumberSelectionMapper.js
// module id = 2080
// module chunks = 8